import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { isSafeAccount } from 'modules/api/methods/isSafeAccount';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

export const { useGetIsSafeAccountQuery, useLazyGetIsSafeAccountQuery } =
  api.injectEndpoints({
    endpoints: build => ({
      getIsSafeAccount: build.query<boolean, IConnectedActionParams>({
        queryFn: async () => {
          const walletClient = getWalletClient();
          if (!walletClient.account?.address) {
            return { data: false };
          }

          const result = await isSafeAccount(
            asAddress(walletClient.account?.address),
          );

          return { data: result };
        },
        providesTags: [cacheTags.account],
      }),
    }),
  });
